import { render, staticRenderFns } from "./RoleSelector.vue?vue&type=template&id=27e2e6a0&scoped=true"
import script from "./RoleSelector.vue?vue&type=script&lang=js"
export * from "./RoleSelector.vue?vue&type=script&lang=js"
import style0 from "./RoleSelector.vue?vue&type=style&index=0&id=27e2e6a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e2e6a0",
  null
  
)

export default component.exports